import React, { useEffect, useState } from 'react';
import service1 from '../../assets/images/our_service_1.png';
import service2 from '../../assets/images/our_service_2.png';
import service3 from '../../assets/images/our_service_3.png';
import { useStyles } from './styles';
import { Box, Typography } from '@mui/material';
import ImgGallery from '../../components/ImgGallery';
import { AnimatedCarousel } from '../../components';
import { imageData } from '../../mocks/home';
import ReviewComponent from './Review';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Home = () => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchReviews = async () => {
            setLoading(true);
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_KEY}/arscustom/public/web/customer-say`
                );
                console.log(i18n.language);
                // Map API response to include language-specific fields
                const formattedReviews = response.data.map(review => ({
                    ...review,
                    name: i18n.language === 'fr-FR' ? review.nameFr : review.nameEn,
                    comment: i18n.language === 'fr-FR' ? review.commentFr : review.commentEn,
                }));
                setReviews(formattedReviews);
                setError(null);
            } catch (error) {
                console.error('Error fetching reviews:', error);
                setError(t('customers_say.error'));
            } finally {
                setLoading(false);
            }
        };

        fetchReviews();
    }, [i18n.language, t]); // Re-fetch if language changes

    return (
        <Box className={classes.container}>
            <Box className={classes.padding}>
                <AnimatedCarousel
                    data={imageData}
                    btn_name="Contact"
                />
            </Box>
            <Box className={classes.service_wrapper}>
                <Box className={classes.titleWrapper}>
                    {t('common.our')}
                    <span className={classes.highlight}>
            {t('our_services.services')}
          </span>
                </Box>
                <Box className={classes.serviceContainer}>
                    <Box
                        className={classes.service_card}
                        sx={{ backgroundImage: `url(${service1})` }}
                    >
            <span className={classes.service_text}>
              {t('our_services.first_service')}
            </span>
                    </Box>
                    <Box
                        className={classes.service_card}
                        sx={{ backgroundImage: `url(${service2})` }}
                    >
            <span className={classes.service_text}>
              {t('our_services.second_service')}
            </span>
                    </Box>
                    <Box
                        className={classes.service_card}
                        sx={{ backgroundImage: `url(${service3})` }}
                    >
            <span className={classes.service_text}>
              {t('our_services.third_service')}
            </span>
                    </Box>
                </Box>
            </Box>
            <Box className={classes.processingWrapper}>
                <Box className={classes.titleWrapper}>
                    {t('processing_time.processing')}
                    <span className={classes.highlight}>
            {t('processing_time.time')}
          </span>
                </Box>
                <ImgGallery />
            </Box>
            <Box className={classes.customerWrapper}>
                <Box className={classes.customertitle}>
                    {t('customers_say.customers')}
                    <span className={classes.highlight}>
            {t('customers_say.say')}
          </span>
                </Box>
                {loading && (
                    <Typography variant="body1" sx={{ textAlign: 'center', my: 2 }}>
                        {t('common.loading')}
                    </Typography>
                )}
                {error && (
                    <Typography variant="body1" color="error" sx={{ textAlign: 'center', my: 2 }}>
                        {error}
                    </Typography>
                )}
                {!loading && !error && reviews.length === 0 && (
                    <Typography variant="body1" sx={{ textAlign: 'center', my: 2 }}>
                        {t('customers_say.no_reviews')}
                    </Typography>
                )}
                {!loading && !error && reviews.length > 0 && (
                    <Box className={classes.review_container}>
                        <ReviewComponent reviews={reviews} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Home;